import { createSelector } from "@reduxjs/toolkit";


export const hasPermission = (state, permission) => {
    const user = state.user.user;
    if (!user || !user?.all_permissions) return false;
    return user?.all_permissions.includes(permission) || user?.role === "admin";
};